module.exports = __webpack_public_path__ + "img/ds-up.169a1918.svg";